<template>
  <el-popover
    placement="bottom-start"
    width="400"
    trigger="click"
    popper-class="kr-history-popover"
    @show="onShow"
  >
    <div class="krh">
      <div class="krh__title aq-form-label">{{ $t('performance.goals.kr_history_title') }}</div>

      <!-- Row rendering shared with the KR detail dialog (KrTimelineList).
           The popover keeps its 10-row cap + "Show all"; the dialog shows
           everything with its own scroll. -->
      <KrTimelineList ref="list" :key-result="keyResult" :cap="VISIBLE_CAP" />
    </div>

    <span slot="reference" class="krh-reference"><slot /></span>
  </el-popover>
</template>

<script>
import KrTimelineList from './KrTimelineList.vue';

const VISIBLE_CAP = 10;

export default {
  name: 'KrHistoryPopover',
  components: { KrTimelineList },
  props: {
    keyResult: { type: Object, required: true },
  },
  data() {
    return {
      VISIBLE_CAP,
    };
  },
  methods: {
    onShow() {
      // Re-collapse to the capped view on every open.
      if (this.$refs.list) this.$refs.list.reset();
    },
  },
};
</script>

<style scoped>
.krh {
  padding: 12px 0 6px;
}

.krh__title {
  padding: 0 14px 8px;
}

.krh-reference {
  display: block;
  min-width: 0;
}
</style>

<!-- The popover popper is teleported to body, so its shell is styled globally
     via popper-class — consistent with the happily-dropdown-popper recipe
     (8px radius, #e2e4ea border, soft 0 10px 25px shadow). -->
<style>
.el-popover.kr-history-popover {
  padding: 0;
  border-radius: 8px;
  border: 1px solid #e2e4ea;
  box-shadow: 0 10px 25px rgba(17, 24, 39, 0.08);
}
</style>
